import { memo, Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

const HeaderActions = () => (
  <Suspense>
    <Routes>
      <Route path="*" element={null} />
    </Routes>
  </Suspense>
)

export default memo(HeaderActions)
